export function UpdateRecordsPerPageOption(totalRows) {
    const RecordsPerPageOption = [];
    if (totalRows > 5) RecordsPerPageOption.push(5);
    if (totalRows > 10) RecordsPerPageOption.push(10);
    if (totalRows > 15) RecordsPerPageOption.push(15);
    if (totalRows > 20) RecordsPerPageOption.push(20);
    if (totalRows > 25) RecordsPerPageOption.push(25);
    return RecordsPerPageOption;
}